import { render, staticRenderFns } from "./pane-risk.vue?vue&type=template&id=1578387a&scoped=true"
import script from "./pane-risk.vue?vue&type=script&lang=js"
export * from "./pane-risk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1578387a",
  null
  
)

export default component.exports